import { BrowserAnimationsModule } from "@angular/platform-browser/animations"; // this is needed!
import { NgModule } from "@angular/core";
import {
  NgbDropdownConfig,
  NgbInputDatepickerConfig,
  NgbPopoverConfig,
  NgbTooltipConfig,
  NgbTypeaheadConfig
} from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppComponent } from "./app.component";

import { CoreModule } from "./core/core.module";
import { LayoutModule } from "./layout/default/layout.module";
import { FreeNasLayoutModule } from "./layout/free-nas/free-nas-layout.module";
import { RoutesModule } from "./routes/routes.module";
import { ToastrModule } from "ngx-toastr";

import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { AngularFireModule } from "@angular/fire";
import { environment } from "../environments/environment";
import { InterceptConection } from "./interceptors/conection.interceptor";
import { CancelInterceptor } from "./interceptors/http.interceptor";
import { NgxIndexedDBModule, DBConfig } from "ngx-indexed-db";
import { name_db, tables_db, version_db } from "./routes/services/db/constants";
import { TimingInterceptor } from "./interceptors/timing.interceptor";

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
const dbConfig: DBConfig = {
  name: name_db,
  version: version_db,
  objectStoresMeta: tables_db
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    ToastrModule.forRoot({ closeButton: true }),
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule,
    LayoutModule,
    FreeNasLayoutModule,
    RoutesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    NgxIndexedDBModule.forRoot(dbConfig)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptConection,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CancelInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * Los popups de ng-bootstrap se agregan al <body> por defecto. El zoom por
   * resolucion se aplica en <app-root> (ver AppComponent.applyResolutionZoom), asi
   * que en el <body> quedan fuera del zoom y ng-bootstrap los posiciona bien en
   * Chrome, Firefox y Safari. Dentro de un ancestro con "zoom" mezcla coordenadas
   * visuales con px CSS y el popup aparece desplazado.
   * @param dropdown configuracion global de ngbDropdown.
   * @param popover configuracion global de ngbPopover.
   * @param tooltip configuracion global de ngbTooltip.
   * @param typeahead configuracion global de ngbTypeahead.
   * @param datepicker configuracion global de ngbDatepicker en input.
   */
  constructor(
    dropdown: NgbDropdownConfig,
    popover: NgbPopoverConfig,
    tooltip: NgbTooltipConfig,
    typeahead: NgbTypeaheadConfig,
    datepicker: NgbInputDatepickerConfig
  ) {
    dropdown.container = "body";
    popover.container = "body";
    tooltip.container = "body";
    typeahead.container = "body";
    datepicker.container = "body";
  }
}
